export interface IEmployeeDetail {
  Title: string;
  eMail: String;
}

export function getEmployeeDetail(
  email: string,
  employees: any[],
  software: any
): IEmployeeDetail[] {

  email = email.toLowerCase()

  let employee1: any[] = [];
  try {
    employee1 = employees?.filter((employee) => employee.eMail === email);
  } catch (error) {}
  let employee2: any[] = [];
  try {
    employee2 = software
      ?.filter((employee: any) => employee?.eITStaff?.split("|")[0] === email)
      ?.map((employee: any) => {
        return {
          Title: employee.eITStaff.split("|")[1],
          eMail: employee.eITStaff.split("|")[0],
        };
      });
  } catch (error) {}

  return [...employee1, ...employee2];
}
